var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { map } from "rxjs/operators";
import { environment } from "../../environments/environment";
import { BehaviorSubject, Subject } from "rxjs";
import { ClevertapEventsService } from "../services/clevertap.service";
import { SessionService } from "../services/session.service";
import * as JSZip from "jszip";
import * as FileSaver from "file-saver";
import * as moment from "moment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { ApplicationEntityModel, CandidatesEntityModel, JobOffer, } from "../interfaces";
import { DP_FORMAT } from "app/views/jobOffers/edit-join-offer/exports";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./session.service";
var JobOffersService = /** @class */ (function () {
    function JobOffersService(http, sessionService) {
        this.http = http;
        this.sessionService = sessionService;
        this.massiveDownload = new BehaviorSubject({
            label: "Download",
            loading: false,
        });
        this.massiveDownloadEnable = true;
        this.massiveDownload$ = this.massiveDownload.asObservable();
        this.jobExternalStatus = new Subject();
        this.jobExeternal = this.jobExternalStatus.asObservable();
    }
    JobOffersService.prototype.downloadPdf = function (id) {
        // employer/curricula
        return this.http.get("" + environment.baseUrlWs + environment.wsVerison + "employer/curricula/" + id + "/cv", { responseType: "arraybuffer" });
    };
    JobOffersService.prototype.downloadMassive = function (jobId, filters, version) {
        if (filters === void 0) { filters = null; }
        if (version === void 0) { version = "v5"; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                        var candidates, totCandidates, candidatesId, results, _loop_1, _i, candidatesId_1, c, zip, i, that_1;
                        var _this = this;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    this.massiveDownload.next({
                                        loading: true,
                                        label: "Preparing ...",
                                    });
                                    return [4 /*yield*/, this.getCurriculaJobOfferByVersion(jobId, version, 0, 500, filters).toPromise()];
                                case 1:
                                    candidates = _a.sent();
                                    totCandidates = candidates.response.list.length;
                                    candidatesId = [];
                                    ClevertapEventsService.emitEvent("downloadCVs", {
                                        total: candidates.response.list.length,
                                    });
                                    candidates.response.list.map(function (c) {
                                        return candidatesId.push({
                                            call: _this.downloadPdf(Number(c.id)),
                                            fileName: c.id + "-" + c.User.name + "-" + c.User.surname,
                                        });
                                    });
                                    results = [];
                                    _loop_1 = function (c) {
                                        var result;
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4 /*yield*/, new Promise(function (resolve, reject) {
                                                        _this.massiveDownload.next({
                                                            label: "Downloading " + (results.length + 1) + " of " + totCandidates + " ...",
                                                            loading: true,
                                                        });
                                                        return c.call
                                                            .toPromise()
                                                            .then(function (r) { return resolve(r); })
                                                            .catch(function (e) { return resolve(null); });
                                                    })];
                                                case 1:
                                                    result = _a.sent();
                                                    if (result) {
                                                        results.push({
                                                            file: result,
                                                            fileName: c.fileName,
                                                        });
                                                    }
                                                    return [2 /*return*/];
                                            }
                                        });
                                    };
                                    _i = 0, candidatesId_1 = candidatesId;
                                    _a.label = 2;
                                case 2:
                                    if (!(_i < candidatesId_1.length)) return [3 /*break*/, 5];
                                    c = candidatesId_1[_i];
                                    return [5 /*yield**/, _loop_1(c)];
                                case 3:
                                    _a.sent();
                                    _a.label = 4;
                                case 4:
                                    _i++;
                                    return [3 /*break*/, 2];
                                case 5:
                                    if (results.length > 0) {
                                        this.massiveDownload.next({
                                            label: totCandidates + " downloaded ...",
                                            loading: true,
                                        });
                                        zip = new JSZip();
                                        for (i = 0; i < results.length; i++) {
                                            zip.file(results[i].fileName + ".pdf", new Blob([results[i].file], { type: "application/pdf" }), {});
                                        }
                                        this.massiveDownload.next({
                                            label: "Starting generating Zip File ...",
                                            loading: true,
                                        });
                                        that_1 = this;
                                        zip
                                            .generateAsync({ type: "blob" })
                                            .then(function (content) {
                                            FileSaver.saveAs(content, "pdf-cv-export.zip");
                                            that_1.massiveDownload.next({
                                                label: "Download",
                                                loading: false,
                                            });
                                            resolve(true);
                                        })
                                            .catch(function (e) {
                                            that_1.massiveDownload.next({
                                                label: "Download",
                                                loading: false,
                                            });
                                            reject();
                                        });
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        });
    };
    JobOffersService.prototype.getAll = function (page) {
        var queryParams = "";
        if (page) {
            queryParams += "?page=" + page;
        }
        return this.http.get(environment.baseUrlWs +
            environment.wsVerison +
            "employer/jobs/" +
            queryParams);
    };
    JobOffersService.prototype.getJobsV3 = function (page) {
        var url = environment.baseUrlWs + "v3/employer/jobs/";
        var params = new HttpParams();
        params = page ? params.append("page", String(page)) : params;
        // if (page) {
        //   params = params.append("page", String(page));
        // }
        return this.http.get(url, { params: params });
    };
    JobOffersService.prototype.getList = function (only_internal) {
        if (only_internal === void 0) { only_internal = false; }
        return this.http.get(environment.baseUrlWs +
            environment.wsVerison +
            "employer/jobs-list" +
            (only_internal ? "?only_internal=true" : ""));
    };
    JobOffersService.prototype.search = function (position) {
        var queryParams = "";
        if (position) {
            queryParams += "?position=" + position;
        }
        return this.http.get(environment.baseUrlWs +
            environment.wsVerison +
            "employer/jobs/" +
            queryParams);
    };
    JobOffersService.prototype.getById = function (id) {
        return this.http.get(environment.baseUrlWs + environment.wsVerison + "employer/jobs/" + id);
    };
    JobOffersService.prototype.update = function (jobOffer, jobForm) {
        return this.http.put(environment.baseUrlWs +
            "v2/"
            +
                "employer/jobs/" +
            jobOffer.id, jobForm);
    };
    JobOffersService.prototype.create = function (jobOffer, jobForm) {
        return this.http.post(environment.baseUrlWs + environment.wsVerison + "employer/jobs/", jobForm, {});
    };
    JobOffersService.prototype.new = function (data) {
        // const body: FormData = new FormData();
        var url = "" + environment.baseUrlWs + "v3/" + "employer/jobs";
        return this.http.post(url, data);
    };
    JobOffersService.prototype.retrieve = function (id) {
        var url = "" + environment.baseUrlWs + "v3/" + "employer/jobs/retrieve-detail/" + id;
        return this.http.get(url).pipe(
        // tap((response) => console.log(response)),
        map(function (res) {
            return __assign({}, res, { expiration_date: res.expiration_date
                    ? moment(res.expiration_date).format(DP_FORMAT)
                    : null, geolocations: res.Location
                    ? res.Location.map(function (g) {
                        return { id: g.id, name: g.formattedAddress };
                    })
                    : [] });
        })
        // tap((response) => console.log(response)),
        );
    };
    JobOffersService.prototype.updateState = function (id) {
        var url = environment.baseUrlWs + "v1/employer/jobs/" + id + "/update-state";
        return this.http.put(url, {});
    };
    JobOffersService.prototype.updateExpirationDate = function (id, expiration_date) {
        var url = environment.baseUrlWs + "v1/employer/jobs/" + id + "/update-expiration-date";
        return this.http.put(url, { expiration_date: expiration_date });
    };
    JobOffersService.prototype.getCurricula = function (jobs_id, page, size, body, tab) {
        if (body === void 0) { body = {}; }
        if (tab === void 0) { tab = "all"; }
        var query = "?page=0";
        if (page) {
            query = "?page=" + page;
        }
        if (size) {
            query += "&size=" + size;
        }
        query += "&tab=" + tab;
        return this.http.post(environment.baseUrlWs +
            "v2/employer/jobs/" +
            jobs_id +
            "/curricula" +
            query, body);
    };
    JobOffersService.prototype.getCurriculaJobOffer = function (jobOffersId, page, limit, body) {
        if (body === void 0) { body = {}; }
        var url = environment.baseUrlWs + "v3/employer/jobs/" + jobOffersId + "/curricula";
        var query_params = new HttpParams();
        query_params = query_params.append("page", String(page || 0));
        query_params = query_params.append("limit", String(limit || 20));
        // if (params) {
        //   // query_params = {...query_params, ...params} as HttpParams;
        //   for (const key in params) {
        //     // console.log(`${key}: ${user[key]}`);
        //     query_params = query_params.append(`${key}`, `${params[key]}`);
        //   }
        // }
        return this.http.post(url, body, {
            params: query_params,
        });
    };
    JobOffersService.prototype.getCurriculaJobOfferV4 = function (jobOffersId, page, limit, body) {
        if (body === void 0) { body = {}; }
        var url = environment.baseUrlWs + "v5/employer/jobs/" + jobOffersId + "/curricula";
        var query_params = new HttpParams();
        query_params = query_params.append("page", String(page || 0));
        query_params = query_params.append("limit", String(limit || 20));
        // if (params) {
        //   // query_params = {...query_params, ...params} as HttpParams;
        //   for (const key in params) {
        //     // console.log(`${key}: ${user[key]}`);
        //     query_params = query_params.append(`${key}`, `${params[key]}`);
        //   }
        // }
        return this.http.post(url, body, {
            params: query_params,
        });
    };
    JobOffersService.prototype.getCurriculaJobOfferByVersion = function (jobOffersId, version, page, limit, body) {
        if (version === void 0) { version = "v4"; }
        if (body === void 0) { body = {}; }
        var url = "" + environment.baseUrlWs + version + "/employer/jobs/" + jobOffersId + "/curricula";
        var query_params = new HttpParams();
        query_params = query_params.append("page", String(page || 0));
        query_params = query_params.append("limit", String(limit || 20));
        return this.http.post(url, body, {
            params: query_params,
        });
    };
    JobOffersService.prototype.deleteJobOffer = function (id) {
        return this.http.delete(environment.baseUrlWs + environment.wsVerison + "employer/jobs/" + id);
    };
    JobOffersService.prototype.externalCheck = function (version) {
        this.jobExternalStatus.next(version);
    };
    JobOffersService.prototype.getActiveJobOffersStatus = function () {
        return this.http.get(environment.baseUrlWs +
            environment.wsVerison +
            "employer/common/job-offers-status");
    };
    JobOffersService.prototype.changeApplicationProcessStatus = function (id, process_status) {
        return this.http
            .put(environment.baseUrlWs +
            environment.wsVerison +
            "employer/jobs/application/" +
            id +
            "/process-status", {
            process_status: process_status,
        })
            .toPromise();
    };
    JobOffersService.prototype.getAllApplications = function (userId) {
        var url = environment.baseUrlWs + "v3/employer/jobs/get-applications/" + userId;
        return this.http.get(url);
    };
    JobOffersService.ngInjectableDef = i0.defineInjectable({ factory: function JobOffersService_Factory() { return new JobOffersService(i0.inject(i1.HttpClient), i0.inject(i2.SessionService)); }, token: JobOffersService, providedIn: "root" });
    return JobOffersService;
}());
export { JobOffersService };
